import API from "store/api"
import { RECEIVED_POSTS, LOADING_POSTS, SET_SORT } from "types/actions/posts"
import { setIsLoading } from "../actions/isLoading"
import { uploadPostImage } from "actions/cloudinary"
import { UPDATE_POST } from "types/actions/posts"
import { isPWA } from "utils/isPWA"
import { openSnackBar } from "./snack-bar"
// import { facebookPost } from "actions/facebook"

// /* eslint-disable */
// (function() {
//   console.log("TEST")
//   return (dispatch, getState) => {
//     const state = getState()
//     const currentOrgId = state.organization.currentOrg.id
//     console.log({state})
//     API.set("TEST", currentOrgId)
//   }
// })()
// /* eslint-enable */

export const SortBy = {
  BY_DATE: "BY_DATE",
  BY_NAME: "BY_NAME"
}

export const receivedPosts = data => ({
  type: RECEIVED_POSTS,
  data
})

export const loadingPosts = data => ({
  type: LOADING_POSTS
})

export const activeSort = sort => ({
  type: SET_SORT,
  sort
})

export const _updatePost = (id, updates) => ({
  type: UPDATE_POST,
  id,
  updates
})

export const getPosts = (type = "all", loadPosts = true) => {
  return (dispatch, getState) => {
    let currentOrgId

    if (isPWA()) {
      currentOrgId = getState().organization.currentOrg.id
      API.set("currentOrgId", currentOrgId)
    }

    // Reset post state
    dispatch(receivedPosts({}))

    if (loadPosts) {
      dispatch(loadingPosts())
    }

    API.get(`/posts/${type}`)

      .then(response => response.body)

      .then(body => {
        dispatch(receivedPosts(body))
        if (loadPosts) {
          dispatch(loadingPosts())
        }
      })
      .catch(error => {
        if (loadPosts) {
          dispatch(loadingPosts())
        }
        console.log(error)
      })
  }
}

export const deletePost = id => {
  return (dispatch, getState) => {
    let currentOrgId

    if (isPWA()) {
      currentOrgId = getState().organization.currentOrg.id
      API.set("currentOrgId", currentOrgId)
    }

    const deferred = new Promise((resolve, reject) => {
      API.del("/posts")
        .send({ id: id })
        .then(res => {
          resolve(res)
          dispatch(getPosts("all", false))
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
    })

    return deferred
  }
}

export const submitPost = data => {
  const { description, file, user_id, org_id, location } = data

  return (dispatch, getState) => {
    let currentOrgId

    if (isPWA()) {
      currentOrgId = getState().organization.currentOrg.id
      API.set("currentOrgId", currentOrgId)
    }

    dispatch(setIsLoading(true))
    const deferred = new Promise((resolve, reject) => {
      dispatch(uploadPostImage(file))
        .then(response => {
          // console.log("CLOUDINARY:", response)

          API.post("/posts")
            .send({
              user_id: user_id,
              org_id: org_id,
              title: "",
              body: description,
              image: JSON.stringify(response),
              location: location
            })
            .then(response => {
              // console.log(response.statusCode)
              dispatch(setIsLoading(false))
              if (response.statusCode === 200) {
                resolve(response)
              } else {
                reject(response)
              }
            })
            .catch(error => {
              dispatch(setIsLoading(false))
              reject(new Error(error))
              dispatch(openSnackBar({ message: error.message }))
            })
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
    return deferred
  }
}

export const publishPost = (id, data) => {
  // console.log("post")
  return (dispatch, getState) => {
    let currentOrgId

    if (isPWA()) {
      currentOrgId = getState().organization.currentOrg.id
      API.set("currentOrgId", currentOrgId)
    }

    const deferred = new Promise((resolve, reject) => {
      API.put(`/posts/publish/${id}`)
        .send(data)
        .then(result => {
          // console.log("RESULT:", result.text)
          resolve(result.text)
        })
        .catch(error => {
          reject(error)
        })
    })
    return deferred
  }
}

export const updatePost = (id, data) => {
  return (dispatch, getState) => {
    let currentOrgId

    if (isPWA()) {
      currentOrgId = getState().organization.currentOrg.id
      API.set("currentOrgId", currentOrgId)
    }
    const deferred = new Promise((resolve, reject) => {
      API.put(`/posts`)
        .send({ id, ...data })
        .then(result => {
          if (result.body.message === "Post successfully updated") {
            dispatch(_updatePost(id, data))
            resolve(result)
          } else {
            reject(result.text)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
    return deferred
  }
}

export const notifications = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.post(`/posts/notifications`)
        .send(data)
        .then(response => {
          resolve(response)
        })

        .catch(error => reject(error))
    })
    return deferred
  }
}



// WEBPACK FOOTER //
// ./src/actions/posts.js